var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"post-body",style:({ maxWidth: `${_vm.maxWidth}px` })},[_c('div',{staticClass:"header-title"},[_vm._t("default")],2),_c('div',{staticClass:"subheader"},[_vm._t("subheader")],2),(_vm.shouldAddDivider)?_c('div',[_c('PostDivider')],1):_vm._e(),_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }